import script from "./VerticalLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalLayout.vue?vue&type=script&setup=true&lang=ts"

import "./VerticalLayout.vue?vue&type=style&index=0&id=ee7c632a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee7c632a"]])

export default __exports__